import { useEffect, useRef, useState } from "react";

const stats = [
  { value: "+500", label: "Lecturas realizadas", sub: "Clientes satisfechos" },
  { value: "+10", label: "Años de experiencia", sub: "Guía espiritual" },
];

export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre-mi" className="py-24 md:py-32 bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          {/* Image */}
          <div className="relative">
            <div className="relative w-full h-[500px] md:h-[580px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/9d8cfb7979fc745e2d4072c466ad6183/c87e8b4818cd7d03222f3bfdb4a89ed4.jpeg"
                alt="Celeste, lectora de tarot"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0a07]/40 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full border-2 border-[#C9A84C]/30 hidden md:block"></div>
            <div className="absolute -top-6 -left-6 w-20 h-20 rounded-full border border-[#C9A84C]/20 hidden md:block"></div>
          </div>

          {/* Content */}
          <div>
            <p className="text-[#C9A84C] text-sm tracking-[0.3em] uppercase mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Sobre mí
            </p>
            <h2
              className="text-4xl md:text-5xl font-light text-[#1a1208] leading-tight mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Hola, soy<br />
              <span className="italic text-[#C9A84C]">Celeste</span>
            </h2>
            <p className="text-[#5a4a35] text-base leading-relaxed mb-5">
              Soy lectora de tarot profesional con más de 10 años de experiencia acompañando a personas en momentos de cambio, duda y búsqueda interior. Mi camino con el tarot comenzó como una herramienta de autoconocimiento y se convirtió en mi vocación.
            </p>
            <p className="text-[#5a4a35] text-base leading-relaxed mb-10">
              Cada lectura es un espacio sagrado de escucha y reflexión. Mi enfoque es empático, honesto y siempre orientado a tu crecimiento personal. No te digo lo que quieres oír, sino lo que necesitas ver.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.value}
                  className="bg-white rounded-xl p-6 border border-[#e8dcc8]"
                >
                  <p
                    className="text-4xl font-light text-[#C9A84C] mb-1"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {stat.value}
                  </p>
                  <p className="text-[#1a1208] text-sm font-semibold">{stat.label}</p>
                  <p className="text-[#9a8a75] text-xs mt-1">{stat.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
